var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_3467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66666 69V19.1667C7.66666 14.9325 11.0991 11.5 15.3333 11.5H29.0522C32.0775 11.5 34.9809 12.6921 37.1333 14.8179L39.5541 17.2088C40.2716 17.9175 41.2394 18.3148 42.2478 18.3148H72.8333C79.1846 18.3148 84.3333 23.4635 84.3333 29.8148V69C84.3333 75.3513 79.1846 80.5 72.8333 80.5H19.1667C12.8154 80.5 7.66666 75.3513 7.66666 69ZM76.6667 38.3333V29.8148C76.6667 27.6977 74.9504 25.9815 72.8333 25.9815H42.2478C39.2225 25.9815 36.3191 24.7894 34.1667 22.6636L31.7459 20.2726C31.0284 19.564 30.0606 19.1667 29.0522 19.1667H15.3333V38.3333H46C48.1171 38.3333 49.8333 40.0496 49.8333 42.1667C49.8333 44.2838 48.1171 46 46 46H15.3333V69C15.3333 71.1171 17.0496 72.8333 19.1667 72.8333H72.8333C74.9504 72.8333 76.6667 71.1171 76.6667 69V46H61.3333C59.2162 46 57.5 44.2838 57.5 42.1667C57.5 40.0496 59.2162 38.3333 61.3333 38.3333H76.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_3467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTabIcon);
export default __webpack_public_path__ + "static/media/folder-tab-icon.0717f82d577fdfa15ec48765964fde37.svg";
export { ForwardRef as ReactComponent };